if (!customElements.get('cart-drawer')) {
  class CartDrawer extends HTMLElement {
    constructor() {
      super();
    }

    open() {
      this.classList.add('is-open');
      // bodyScroll.lock(this.parentElement);
    }

    close() {
      this.classList.remove('is-open');
      // bodyScroll.clear(this.parentElement);
      document.dispatchEvent(new CustomEvent('closeGiftDrawer'));
    }

    update(event) {
      const html = new DOMParser().parseFromString(event.detail.html, 'text/html');
      if(!html) return;

      const cartDrawer = html.querySelector('cart-drawer');
      if(!cartDrawer) return;

      this.innerHTML = cartDrawer.innerHTML;

      this.setCartBodyMaxHeight();
      this.open();
    }

    setCartBodyMaxHeight() {
      this.cartHead = this.querySelector('.js-cart-head');
      this.cartActions = this.querySelector('.js-cart-actions');
      let maxHeight = window.innerHeight;

      if(this.cartHead) maxHeight -= this.cartHead.offsetHeight;
      if(this.cartActions) maxHeight -= this.cartActions.offsetHeight;

      this.style.setProperty('--cart-body-max-height', maxHeight + 'px');
    }

    connectedCallback() {
      this.addEventListener('click', (event) => {
        if (!event.target.closest('.js-close')) return;
        event.preventDefault();
        this.close();
      });

      document.addEventListener('alexa:open-cart', this.open.bind(this));

      document.addEventListener('alexa:update-cart', this.update.bind(this));

      document.addEventListener('keyup', (event) => {
        if(event.code && event.code.toUpperCase() === 'ESCAPE') this.close();
      });

      this.setCartBodyMaxHeight();

      window.addEventListener('resize', this.setCartBodyMaxHeight.bind(this));
    }
  }

  customElements.define('cart-drawer', CartDrawer);
}
